import React, { useContext } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import styled from 'styled-components';
import Activate from './Activate';
import Restore from './Restore';
import { PublicPasswordContext } from '../../context/PublicPasswordContext';

const Password = () => {
    const publicPasswordContext = useContext(PublicPasswordContext);
    const StyledDiv = styled.div`
        a:visited {
            color: ${publicPasswordContext.organizationData.linkColor};
        }
        a:link {
            color: ${publicPasswordContext.organizationData.linkColor};
        }
        a:active {
            color: ${publicPasswordContext.organizationData.linkColor};
        }
    `;

    return (
        <div style={{ background: publicPasswordContext.organizationData.backgroundColor }} className="backgroundDiv">
            <div className="container">
                <div className="row pb-4" style={publicPasswordContext.style.header}>
                    <div className="col">
                        <Header />
                    </div>
                </div>
                <StyledDiv>
                    {publicPasswordContext.path === 'aktivera' && <Activate />}
                    {publicPasswordContext.path === 'aterstall' && <Restore />}
                    <Footer />
                </StyledDiv>
            </div>
        </div>
    );
}

export default Password;